export class TipoLocalidade {
  id: number;
  tipo: string;
  ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidades-tipos/localidade-tipos.model.ts
 **/